import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledSignInModal = styled.div`
  input[type='checkbox'] + label {
    color: #1c1c1c !important;
  }
  .right-container {
    a {
      color: #1c1c1c !important;
    }
  }

  .sign-in-modal {
    border-radius: ${toRem(12)};
    background-color: #fff;
    overflow: hidden;
    max-width: 60.25rem;
    width: 100%;
    max-height: calc(100vh - ${toRem(64)});
    margin: 3rem auto 0 auto;
    color: black !important;

    hr {
      margin: 24px 0;
      border: none;
      border-top: 1px solid rgba(0, 0, 0, 0.2);
      width: 100%;
    }

    .ctn-button {
      border-radius: 52px;
    }

    .modal-header {
      border: none;
      display: grid;
      justify-content: end;
      margin-bottom: -93px;

      @media (max-width: 576px) {
        margin-bottom: -35px;
      }
    }

    .modal-body {
      padding: 0;

      @media only screen and (min-width: 576px) {
        max-height: 86vh;
      }

      .modal-content {
        display: flex;
        flex-direction: row;
        width: 100%;
        padding: ${toRem(64)};
        gap: ${toRem(32)};

        @media (max-width: 576px) {
          flex-direction: column;
          padding: ${toRem(20)};
          gap: ${toRem(20)};
        }
      }

      .join-now-block,
      .sign-in-block {
        width: 50%;

        @media (max-width: 576px) {
          width: 100%;
        }
      }

      .join-now-block {
        background-color: rgb(238, 238, 238);
        display: flex;
        flex-direction: column;
        justify-content: center;

        @media (max-width: 576px) {
          margin-left: 0;
          text-align: left;
          align-items: flex-start;
        }

        .logo-container {
          margin-bottom: ${toRem(36)};
          padding-left: 3rem !important;
          margin-top: 1.5rem;

          @media (max-width: 576px) {
            padding-left: 3rem !important;
            margin: 0 0 2rem 0;
          }

          .logo {
            font-size: ${toRem(58)};
            margin-top: 1rem;
          }
        }

        h3 {
          font-size: 22px;
          font-weight: 700;
          padding-left: 3rem;
          margin-bottom: ${toRem(16)};
          color: #1c1c1c;

          @media (max-width: 576px) {
            width: 100%;
          }
        }

        .benefits {
          padding: 0;
          list-style: none;
          padding-left: 3rem;
          font-size: 22px;
          font-weight: 700;

          li {
            font: normal normal 500 1rem / 1.5rem var(--t-base-font-family);
            padding-bottom: 0.5rem;
            position: relative;
            padding-left: 1.25rem;

            &::before {
              content: '•';
              position: absolute;
              left: 0;
              top: 0;
              color: #000;
              font-size: 18px;
              line-height: 1.2;
            }
          }

          @media (max-width: 576px) {
            width: 100%;
            text-align: left;
          }
        }
        @media (max-width: 576px) {
          .join-guest {
            padding: 0rem 8rem 1rem 3rem !important;
          }
        }
        @media (max-width: 576px) {
          .join-guest-mobile,
          .m-button-m a {
            line-height: 0px !important;
            padding-top: 0rem !important;
          }
        }
        .m-button-secondary:hover {
          box-shadow: none;
        }
        join-guest-btn:hover {
          background: #1c1c1c !important;
          color: rgb(255 255 255) !important;
          cursor: pointer !important;
        }
        .join-guest {
          a:hover {
            background: #1c1c1c !important;
            color: rgb(255 255 255) !important;
            cursor: pointer !important;
          }
        }
        .continue-guest {
          a:hover,
          span:hover {
            color: #1c1c1c !important;
            cursor: pointer !important;
          }
        }
        .join-guest,
        .continue-guest {
          padding-left: 3rem;
          width: 90%;
          .links-wrapper {
            color: #1c1c1c !important;
          }

          a,
          span {
            font-weight: 700;
            border-radius: 52px;
            color: #1c1c1c !important;
          }
          .border-color {
            border: 1px solid #1c1c1c;
          }

          @media (max-width: 576px) {
            width: 100%;
            padding: 1rem 7rem;
          }
        }
      }
    }
  }
  #forgotpassword,
  #forgotpassword:link,
  #forgotpassword:visited,
  #forgotpassword:hover,
  #forgotpassword:active,
  #forgotpassword:focus,
  #activateonlineaccount,
  #activateonlineaccount:link,
  #activateonlineaccount:visited,
  #activateonlineaccount:hover,
  #activateonlineaccount:active,
  #activateonlineaccount:focus {
    color: black !important;
  }

  @media (max-width: 576px) {
    .sign-in-modal {
      max-width: 100% !important;
      width: 100% !important;
      height: 100dvh !important;
      max-height: 100dvh !important;
      margin: 0 !important;
      border-radius: 0 !important;
      overflow-y: auto !important;
      top: 5rem;
      hr {
        margin: 12px 0;
      }

      .modal-body {
        top: 3rem;
        overflow-y: auto !important;
        margin-top: 1rem;
        height: 70dvh !important;
        max-height: 70dvh !important;
      }

      .modal-content {
        flex-direction: column-reverse !important;
        padding: ${toRem(16)} !important;
        gap: ${toRem(16)} !important;
      }
    }
  }
`;
